;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingTips = Marionette.ItemView.extend({
		template: JST.TippingTips,
		data: {},
		is_draw_enabled: false,
		initialize: function() {

			this.round_id          = this.getOption('round_id');
			this.rounds            = this.getOption('rounds');
			this.squads            = this.getOption('squads');
			this.venues            = this.getOption('venues');
			this.ladderPredictor   = this.getOption('ladderPredictor');
			this.getting_data      = false;
			this.data.margin_range = 100;

			this.timer_circle_color = '#60686F';
			this.timer_circle_bg    = '#0f7ad2';

			this.widget_tips = this.getOption('widget_tips');

			var collections = [this.rounds, this.squads, this.venues],
				complete = _.invoke(collections, 'fetch', {cache: true, expires: 60 });

			$.when.apply(null, complete)
				.done(_.bind(this.initListeners, this));
		},

		saveLoginTipList: function() {
			var landing_tips = APP.getJStorage('landing_tips'),
				ladder_predictor = APP.getJStorage('saved_ladder_predictor');

			if(landing_tips && landing_tips.length){

				var complete = [
					this.model.save_list({tips: landing_tips})
				];

				if(ladder_predictor && ladder_predictor.length){
					complete.push(this.ladderPredictor.save_manual().save({'ladder': ladder_predictor}));
				}

				$.when.apply(null, complete)
					.then(_.bind(function() {

						this.setSelectedRound();
						APP.setJStorage('landing_tips', []);
						APP.setJStorage('saved_ladder_predictor', []);

					}, this));
			}
			else{
				this.setSelectedRound();
			}

			return this;
		},

		initListeners: function() {

			this.listenTo(APP.vent, 'tipping:round:change',_.bind(this.setSelectedRound, this));

			this.listenTo(APP.vent, 'tipping:save_list', _.bind(this.saveTipList, this));

			this.listenTo(APP.vent, 'tipping:tips:update', _.bind(function(data) {
				this.collection.reset();
				this.collection.set(data);
				this.getUserTips(data);
			}, this));

			this.subscribeChecksum();

			return this.saveLoginTipList();
		},

		onDestroy: function() {
			$( window ).off('resize', this.refreshMarginSlider);
		},

		ui: {
			tip:              '.js-tip',
			tip_team:         '.js-tip-team',
			active_tip:       '.js-tip-team.active',
			days:             '.days',
			save_tips:        '.js-save-tips',
			fill_popular:     '.js-set-popular-tips',
			fill_random_tips: '.js-set-random-tips',
			tips_count:       '.js-tips-count',
			tips_saved_msg:   '.js-tips-saved-msg',
			round_match:      '.js-round-match',
			nst_slider:       '.js-nst-slider',
			home_points:      '.js-home-points',
			away_points:      '.js-away-points',
			tip_home:         '.js-tip-home',
			tip_away:         '.js-tip-away',
			draw_tip:         '.js-draw-tip'
		},

		events: {
			"click @ui.tip":              'updateTipStatus',
			"click @ui.save_tips":        'saveTipList',
			'click @ui.fill_popular':     'fillPopular',
			'click @ui.fill_random_tips': 'fillLuckOfDraw',
			'input @ui.home_points':      'updateMargin',
			'input @ui.away_points':      'updateMargin',
			'click @ui.draw_tip':         'changeDrawTip'
		},

		render: function () {
			var _this = this;

			if (!this.getting_data) {
				return this;
			}
			this.$el.html(this.template(this.data));

			this.bindUIElements();

			this.ui.days.each(function(){
				_this.generateCercles(this);
			}, this);

			this.updateTipsCount().marginSlider();

			return this;
		},

		setSelectedRound: function(round_id) {
			if (!this.rounds.length) {
				return this;
			}

			this.round_id = _.isNumber(round_id) ? round_id : this.rounds.getActualRoundId();

			if (this.widget_tips) {
				this.round_id = this.widget_tips.round_id;
			}

			this.selected_round = this.rounds.get(this.round_id);
			this.selected_round.setWinners();

			this.collection
				.show_my_list()
				.fetch({data: {round: this.round_id}})
				.then(_.bind(function () {
					this.extendSelectedRound().getUserTips().hidePreloader();
					console.log(this.selected_round);
				}, this));

			return this;
		},

		getUserTips: function() {
			var is_need_to_save = false;

			if (this.widget_tips) {
				this.extendUserTipsFromWidgetTips();
				is_need_to_save = true;
			}

			var user_tips = this.collection;

			this.selected_round.get('matches').forEach(function(match) {
				var tip  = user_tips.get(match.id);
				if (tip) {
					match.tip_data = user_tips.get(match.id).toJSON();

					if(match.status == 'complete' && match.tip_data.predict_winner_squad_id == 0) {
						match.is_selected_away = true;
					}
					else {
						var is_home_squad = match.tip_data.predict_winner_squad_id == match.home_squad_id;
						match.is_selected_home = is_home_squad;
						match.is_selected_away = match.tip_data.predict_winner_squad_id == match.away_squad_id;
						match.tip_data.margin_value = is_home_squad ? -1 * match.tip_data.predict_margin : match.tip_data.predict_margin;

						//show in progress until status == complete
						if ( match.status == 'postmatch' ) {
							match.status = 'playing';
						}

						if (match.status !== 'scheduled' && !match.tip_data.is_correct) {
							const is_home = match.is_selected_home && match.is_home_winner;
							const is_away = match.is_selected_away && match.is_away_winner;
							match.tip_data.is_correct = is_home || is_away;
						}
					}
				}
			});

			APP.vent.trigger('tipping:tips:calculate', this.selected_round);

			this.setDataToTemplate(user_tips);

			if (is_need_to_save) {
				this.saveTipList();
			}

			return this;
		},

		extendUserTipsFromWidgetTips: function() {
			var matches_object = _.indexBy(this.selected_round.get('matches'), 'id'),
				widget_tips = this.widget_tips;

			this.collection.each(function(tip) {
				var user_tip = tip.toJSON();

				var is_scheduled_match = matches_object[user_tip.id].status == 'scheduled',
					tipped_from_widget = widget_tips.tips[user_tip.id];

				if (is_scheduled_match && tipped_from_widget) {
					tip.set({
						predict_winner_squad_id: tipped_from_widget
					});
				}
			});

			this.widget_tips = false;

			return this;
		},

		setDataToTemplate: function(user_tips) {
			const withZeroRound = this.rounds.toJSON()[0].id === 0;
			const round_id = withZeroRound ? this.round_id : this.round_id - 1;
			this.setTemplateData({
				image_url:      this.image_url,
				round_id:       round_id,
				rounds:         this.rounds.toJSON(),
				selected_round: this.selected_round.toJSON(),
				user_tip :      user_tips.toJSON(),
				img_url :       this.project_img_url,
				SQUADS_URL :    CONFIG.SQUADS_URL
			});
		},


		extendSelectedRound: function() {
			if (this.selected_round.squad_names) {
				return this;
			}
			this.rounds.setSquadNames(this.round_id, this.squads);
			this.rounds.setVenuesNames(this.round_id, this.venues);

			return this;
		},

		setTemplateData: function(obj) {
			_.extend(this.data, obj);

			this.data.show_margin_msg = APP.getJStorage('show_margin_msg') ? false : true;

			this.getting_data = true;
			this.render();
			return this;
		},

		closeMarginMessage: function(){

			APP.setJStorage('show_margin_msg', true);

			$(this.ui.margin_message).slideUp(100);

			return this;
		},

		updateTipStatus: function(e) {

			var $tip = $(e.currentTarget),
				data = $tip.data();

			if(!$tip.hasClass('active')) {
				this.reverseMarginSlider(
					$(e.currentTarget).closest('.round-content-area'),
					$tip.hasClass('round-contents-left')
				);
			}


			this.hideTipsSaveNotification();

			this.model.save_tip(data).then(_.bind(function(model, response) {

				$tip.parent().find($(this.ui.tip)).removeClass('active');
				$tip.addClass('active');
				this.updateTipsCount();

				this.showTipsSaveNotification();


				APP.vent.trigger('updateCalc', data );

			}, this));
		},

		updateTip: function(data){

			this.model.save_tip(data).then(_.bind(function(model) {

				this.updateTipsCount();

				this.showTipsSaveNotification();


				this.collection.reset(model.result);
				this.getUserTips();

				APP.vent.trigger('updateCalc', data );

				this.render();

			}, this));
		},

		saveTipList: function() {
			var data = {};
			data.tips = [];
			$(this.ui.tip).each(function(){
				if($(this).hasClass('active')) {
					data.tips.push($(this).data())
				}
			});

			this.hideTipsSaveNotification();

			$.when.call(null, this.model.save_list(data)).done(_.bind(function(model, response) {

				this.showTipsSaveNotification();

			}, this));


			return this;
		},

		showTipsSaveNotification: function() {
			$(this.ui.save_tips).find('i').show();
			$(this.ui.save_tips).find('span').html('TIPS SAVED');
			$(this.ui.tips_saved_msg).show();
		},

		hideTipsSaveNotification: function(){
			$(this.ui.save_tips).find('i').hide();
			$(this.ui.save_tips).find('span').html('SAVE TIPS');
			$(this.ui.tips_saved_msg).hide();
		},

		fillPopular: function() {
			return this.autopick('popular');

		},

		fillLuckOfDraw: function() {
			return this.autopick('luck_of_draw');
		},

		autopick: function(type) {

			this.hideTipsSaveNotification();
			$.when.call(null, this.collection.autopick({ round: this.round_id, type: type})).done(_.bind(function(model, response) {
				APP.vent.trigger('tipping:tips:update', model.result);
				this.showTipsSaveNotification();
			}, this));

			return this;
		},

		generateCercles: function(elem){
			var first_match = _.findWhere(this.selected_round.get('matches'), {is_first: 1}),
				start_timer = new Date(first_match.date);

			// Start timer the day before 1st match.
			start_timer.setDate(start_timer.getDate() - 1);

			$(elem).circleTimer({
				start:          start_timer,
				bg_color:       this.timer_circle_color,
				progress_color: this.timer_circle_bg,
				line_width:     3
			});
		},

		marginSlider: function() {
			var $this = this;
			if (!$(this.ui.nst_slider).length) {
				return this;
			}
			$(this.ui.nst_slider).nstSlider({
				"left_grip_selector": ".leftGrip",
				"value_bar_selector": ".bar",
				"value_changed_callback": function (cause, marginValue) {

					var $container = $(this).closest('.margin-content'),
						pts_label  = 'point',
						value      = Math.abs(marginValue),
						home_input = $container.find($this.ui.home_points),
						away_input = $container.find($this.ui.away_points);

					$(this).closest($this.ui.round_match).find('.game-part').data('predict_margin', value);

					home_input.val(0);
					away_input.val(0);

					pts_label = (value > 1) ? 'points' : 'point';
					$container.find('.js-points').html(value+ " " +  pts_label);
					if (marginValue == 0) {
						$container.find('.away-side .points-value').text(value);
					}
					if (marginValue <= 0) {
						home_input.val(value);
						home_input.text(value);
						$container.find('.js-win-team').html($container.data('home-squad'));
					} else {
						away_input.val(value);
						away_input.text(value);
						$container.find('.js-win-team').html($container.data('away-squad'));
					}
				},
				user_mouseup_callback: function(margin) {
					$(this).closest('.round-content-area').find('.active').removeClass('active');
					if( margin >= 0 ) {
						$(this).closest('.round-content-area').find('.round-contents-right').addClass('active');
					} else {
						$(this).closest('.round-content-area').find('.round-contents-left').addClass('active');
					}

					var selected_tip = $(this).closest('.round-content-area').find('.js-tip.active');

					if(selected_tip.length)
						$this.updateTipStatus({currentTarget:selected_tip});
				}
			});

			$('.js-nst-slider').each(function(){
				if($(this).data('aria_disabled')) {
					$(this).nstSlider('disable');
				}
			});

			$( window ).on('resize', this.refreshMarginSlider);
		},

		refreshMarginSlider: function(){
			$('.js-nst-slider').each(function(){
				$(this).nstSlider('refresh');
			});
			return this;
		},

		reverseMarginSlider: function(container, home) {
			var slider        = container.find(this.ui.nst_slider),
				home_input    = container.find(this.ui.home_points),
				away_input    = container.find(this.ui.away_points),
				current_value = 0;

			if(!slider.length) {
				return false;
			}

			if (home) {
				home_input.val(away_input.val());
				current_value = -away_input.val();
				away_input.val(0);
			}
			else {
				away_input.val(home_input.val());
				current_value = home_input.val();
				home_input.val(0);
			}

			slider.nstSlider('set_position', current_value);

			return this;
		},

		updateMargin: function(e){

			var target         = $(e.currentTarget),
				container      = target.closest(this.ui.round_match),
				slider         = container.find(this.ui.nst_slider),
				draw           = container.find(this.ui.draw_tip),
				current_value  = target.val();

			if(current_value > this.data.margin_range) {
				current_value = this.data.margin_range;
				target.val(current_value);
			}

			container.find(this.ui.tip).data('predict_margin', current_value);

			if(target.hasClass('js-home-points')) {
				current_value = -current_value;
				container.find(this.ui.tip_home).trigger('click');
			}
			else {
				container.find(this.ui.tip_away).trigger('click');
			}

			slider.nstSlider('set_position', current_value);

			return this;
		},

		updateTipsCount: function() {
			var all_tips    = $(this.ui.tip_team).length/2;
			var active_tips = $(this.ui.round_match).find('.active').length;
			$(this.ui.tips_count).html(active_tips + '/' + all_tips);
			return this;
		},

		changeDrawTip: function(e){

			var target = $(e.currentTarget),
				target_val = $(e.currentTarget).data('tipId'),
				tip_model = this.collection.get(target_val),
				new_tip_draw_val = tip_model.toJSON().is_draw = ! tip_model.toJSON().is_draw
			;


			tip_model.set({
				is_draw : 1,
				predict_margin : 0
			});

			this.updateTip({ match_id : target_val , is_draw: tip_model.get('is_draw') });

		},


		subscribeChecksum() {
			this.checksumEmitter = this.getOption('checksumEmitter');
			const round = this.rounds.getActualRound();

			if(!round || round.get('status') !== 'active') {
				return this;
			}

			if(!this.checksumEmitter) {
				console.warn('Please enable checksumEmitter in build.json and check if it was initialized in the Controller of Tipping');
				return this;
			}

			this.unSubscribeChecksum()
				.listenTo(this.checksumEmitter, 'change:rounds', () => this.fetchChecksums());

			this.checksumEmitter.requestChecksum();



			return this;
		},

		fetchChecksums(){
			var collections = [ this.rounds ],
				complete = _.invoke(collections, 'fetch', {cache: true, expires: 60 });

			$.when.apply(null, complete).done(() => this.setSelectedRound());
		},

		unSubscribeChecksum() {
			this.stopListening(this.checksumEmitter);

			return this;
		},
	});

}(window, APP, Backbone, Marionette, $, _));
